import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import { createApplicationRouter } from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@pakenergy/design-system/tokens.css";
import "@pakenergy/design-system/assets/fonts/lato/lato.css";
import "@pakenergy/design-system/assets/fonts/manrope/manrope.css"; // secondary typeface, loaded for future component use
import { createAuth0 } from "@auth0/auth0-vue";
import auth0Config from "./auth0Config";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import { vMaska } from "maska/vue";

const app = createApp(App);

// Global filters (replaces Vue.filter and vue-moment)
app.config.globalProperties.$filters = {
  momentFromNow(value) {
    if (!value) return "";
    const m = moment(value);
    return m.isValid() ? m.fromNow() : "";
  },
  formatWithMoment(value, format) {
    if (!value) return "";
    const m = moment(value);
    return m.isValid() ? m.format(format) : "";
  },
  moment(value, format) {
    if (!value) return "";
    const m = moment(value);
    return m.isValid() ? m.format(format) : "";
  },
};

const router = createApplicationRouter(app);

app
  .use(vuetify)
  .use(router)
  .use(store)
  .use(
    createAuth0({
      domain: auth0Config.domain,
      clientId: auth0Config.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: auth0Config.audience,
      },
      useRefreshTokens: true,
      cacheLocation: "localstorage",
    })
  )
  .directive("maska", vMaska)
  .component("vselect", vSelect);

app.mount("#app");
